import TableCellGroup from "ds/components/Table/Row/CellGroup";
import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { SpaceDetailsPolicy } from "../types";

type SpaceDetailsPoliciesNameCellProps = TableSimpleCellProps<SpaceDetailsPolicy> & {
  isExpanded: boolean;
  onToggle: () => void;
};

const SpaceDetailsPoliciesNameCell = ({
  item: policy,
  isExpanded,
  onToggle,
  ...cellProps
}: SpaceDetailsPoliciesNameCellProps) => (
  <TableSimpleCell {...cellProps} role="rowheader">
    <TableCellGroup
      isActive
      isGroupOpen={isExpanded}
      onPress={onToggle}
      title={`Toggle ${policy.name} body preview`}
    >
      <TableCellLink href={`/policy/${policy.id}`}>{policy.name}</TableCellLink>
    </TableCellGroup>
  </TableSimpleCell>
);

export default SpaceDetailsPoliciesNameCell;
